/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        console.log( $( '#gform_page_' + formId + '_' + currentPage ) );
        if ( $( '#gform_page_' + formId + '_' + currentPage ).hasClass( 'final-page' ) ) {
          $( '.multipage-form__page--form-inner, .multipage-form__page--image-final' ).addClass( 'is-final' );
          $( '.multipage-form__footer' ).addClass( 'is-hidden' );
        } else {
          $( '.multipage-form__page--form-inner, .multipage-form__page--image-final' ).removeClass( 'is-final' );
          $( '.multipage-form__footer' ).removeClass( 'is-hidden' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
